import { useMutation } from '@tanstack/react-query';
import type { paths } from '@worldathletics/api-client';

import { apiClient } from '@/lib/api-client';

// Source the request body shape from the generated OpenAPI types so any BE
// schema change surfaces here at compile time.
type ChangePasswordInput =
  paths['/auth/change-password']['post']['requestBody']['content']['application/json'];

export function useChangePasswordMutation() {
  return useMutation({
    mutationFn: async (input: ChangePasswordInput) => {
      const { data, error } = await apiClient.POST('/auth/change-password', {
        body: input,
      });
      if (error || !data) throw error ?? new Error('Change password failed');
      return data;
    },
  });
}
